import InputIcon from './input-icon';

export default InputIcon;
